import SherpaClient from "./main";

export const getQuestions = async (assignment_id) => {
  const response = await SherpaClient.get("/questions/" + assignment_id);
  return response.data;
};
